import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/lead/Data Table";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Switch from "react-switch";

import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Add_data_modal from "../../components/lead/update_data_modal";
import Layouts from "../../layouts/layouts";
import LeadDetailModal from "../../components/lead/Lead Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export

export default function Lead() {
  const title = "Lead Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showLeadDetailModal, setShowLeadDetailModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Date </b>,
      selector: (row) => formatDate(row.timestamp),
      sortable: true,
    },
    // {
    //   name: <b>Address</b>,
    //   selector: (row) => row.address,
    //   sortable: true,
    // },
    {
      name: <b>City</b>,
      selector: (row) => row.address?.split(" ").slice(-1)[0] || "-",
      sortable: true,
    },

    {
      name: <b>Business Name </b>,
      selector: (row) => row.business_name,
      sortable: true,
    },
    {
      name: <b>Customer Name</b>,
      selector: (row) => row.customer_name,
      sortable: true,
    },
    {
      name: <b>Agent Name</b>,
      selector: (row) => row.agent_name,
      sortable: true,
    },
    {
      name: <b>Phone Number</b>,
      selector: (row) => row.phone_number,
      sortable: true,
    },

    {
      name: <b>Business Category</b>,
      selector: (row) => row.business_category?.name || "-",
      sortable: true,
    },

    {
      name: <b>Interested </b>,
      selector: (row) => (row.interested ? "Yes" : "No"),
      sortable: true,
    },
    {
      name: <b>Rating </b>,
      selector: (row) => row.rating,
      sortable: true,
    },
    {
      name: <b>Visit</b>,
      selector: (row) => (row.visit ? "True" : "False"),
      cell: (row) => (
        <Switch onChange={() => handleToggleVisit(row)} checked={row.visit} />
      ),
      sortable: true,
    },
    {
      name: <b>Call</b>,
      selector: (row) => (row.call ? "True" : "False"),
      cell: (row) => (
        <Switch onChange={() => handleToggleCall(row)} checked={row.call} />
      ),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {row.status === "created" && (
            <>
              <button
                onClick={() => copyLink()}
                className=" btn btn-success btn-sm"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
              <button className=" btn btn-primary btn-sm ms-1">
                <FontAwesomeIcon icon={faEnvelope} />
              </button>
            </>
          )}
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className=" btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
          <button
            onClick={() => viewLead(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchLead = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (Array.isArray(response.data.leads)) {
        setApiState(response.data.leads);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.log("Error fetching leads:", error);
    }
  };

  useEffect(() => {
    fetchLead(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const handleToggleCall = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedCall = !row.cll;

      // Create FormData and append the updated geoFencing value
      const formData = new FormData();
      formData.append("call", updatedCall);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const updatedCalls = apistate.map((lead) =>
          lead._id === row._id ? { ...lead, call: updatedCall } : lead
        );
        setApiState(updatedCalls);
        Swal.fire("Updated!", "Call status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Call status.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating Call status:", error);
      Swal.fire("Error!", "There was an error updating Call status.", "error");
    }
  };

  const handleToggleVisit = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedVisit = !row.cll;

      // Create FormData and append the updated geoFencing value
      const formData = new FormData();
      formData.append("visit", updatedVisit);

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const updatedVisits = apistate.map((lead) =>
          lead._id === row._id ? { ...lead, visit: updatedVisit } : lead
        );
        setApiState(updatedVisits);
        Swal.fire("Updated!", " Visit status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Visit status.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating Visit status:", error);
      Swal.fire("Error!", "There was an error updating Visit status.", "error");
    }
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You wont be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}/api/v1/leads/${row._id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            Swal.fire("Deleted!", "Leads has been deleted.", "success");
            fetchLead(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Lead could not be deleted.", "error");
            console.error("Error deleting leads:", error);
          });
      }
    });
  };

  const updateLead = (updatedLead) => {
    setApiState((prev) =>
      prev.map((lead) => (lead._id === updateLead._id ? updateLead : lead))
    );
  };

  const handleUpdateLead = (updatedLeadData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads/${updatedLeadData._id}`,
        updatedLeadData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        Swal.fire("Updated!", "Lead details have been updated.", "success");
        updateLead(response.data.lead);
      })
      .catch((error) => {
        Swal.fire("Error!", "Lead details could not be updated.", "error");
        console.error(
          "Error updating lead:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const viewLead = (lead) => {
    setSelectedLead(lead);
    setShowLeadDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((lead) => ({
      Date: lead.timestamp,
      Agent_Name: lead.agent_name,
      Phone_Number: lead.phone_number,
      Customer_Name: lead.customer_name,
      Business_Name: lead.business_name,
      Address: lead.address,
      Email: lead.email,
      Business_Category: lead.business_category,
      Interested: lead.interested,
      Visit_Remarks: lead.remarks,
      Call_Remarks: lead.callremarks,
      Rating: lead.rating,
      Call: lead.call,
      Visit: lead.visit,

      "Created By": lead.createdBy ? lead.createdBy.user_email : "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Damages");

    XLSX.writeFile(workbook, "leads.xlsx");
  };

  const handleExcelUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/leads/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire("Success!", "Leads imported successfully.", "success");

      // Refresh table
      fetchLead(currentPage);
    } catch (error) {
      Swal.fire("Error!", "Failed to import leads.", "error");
      console.error(
        "Import error:",
        error.response ? error.response.data : error
      );
    }

    // Reset file input to allow re-uploading the same file again
    event.target.value = "";
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateLead={updateLead}
      />
      <LeadDetailModal
        show={showLeadDetailModal}
        onHide={() => setShowLeadDetailModal(false)}
        lead={selectedLead}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    className="btn btn-warning btn-sm text-white me-2"
                    onClick={() =>
                      document.getElementById("excelUpload").click()
                    }
                  >
                    Import Excel
                  </button>

                  {/* Hidden File Input */}
                  <input
                    type="file"
                    id="excelUpload"
                    accept=".xlsx,.xls"
                    style={{ display: "none" }}
                    onChange={handleExcelUpload}
                  />

                  <Link to="/create_lead">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Leads
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    title_btn={true}
                    apidata={apistate}
                    // columns={apicol}
                    columns={columns}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
